import type { TooltipContentProps } from "recharts";
import * as React from "react";
import { getTooltip } from "@wayflyer/flyui-dataviz";

import type { ValueType } from "../../../../components/shared";

export const ltvChartTooltip =
  (formatValue: (rawValue: ValueType, isRef?: boolean) => string | number) =>
  ({ active, payload, label }: TooltipContentProps) => {
    return getTooltip({ active, payload, label, formatValue, useBothReferenceValues: true });
  };

export const XAxisTick: React.FC<any> = (props: any) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={5} textAnchor="end" fill="#666" transform="rotate(-90)">
        {payload.value}
      </text>
    </g>
  );
};
